import { render, staticRenderFns } from "./user-contracts.vue?vue&type=template&id=b8f0cba6&scoped=true&"
import script from "./user-contracts.vue?vue&type=script&lang=js&"
export * from "./user-contracts.vue?vue&type=script&lang=js&"
import style0 from "./user-contracts.vue?vue&type=style&index=0&id=b8f0cba6&prod&lang=css&"
import style1 from "./user-contracts.vue?vue&type=style&index=1&id=b8f0cba6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f0cba6",
  null
  
)

export default component.exports